import React from 'react';
import ReportBackNav from './ReportBackNav';

const withLendingReportBack = (Component) => {
  const Wrapped = (props) => (
    <>
      <ReportBackNav />
      <Component {...props} />
    </>
  );

  Wrapped.displayName = `withLendingReportBack(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
};

export default withLendingReportBack;
